import type { ReportPermissions } from './reportPermissions';

/**
 * Zustand der Aktionsleiste der Meldungsseite (Phase 43, D-01/D-02/D-08). Reine Funktion aus
 * den Rechten (`reportPermissions`) -- die Seite rendert ausschliesslich daraus.
 *
 * Keine Sperre bei ungespeicherten Aenderungen (O-3): Einreichen, Rueckgabe und Genehmigen
 * speichern vor ihrer Aktion selbst (ReportEditPage).
 *
 * Keine React-Importe -- muss unter `environment: 'node'` ladbar bleiben.
 */
export interface ActionBarState {
  showSave: boolean;
  showSubmit: boolean;
  showReturn: boolean;
  showApprove: boolean;
}

export function actionBarState(permissions: ReportPermissions | null): ActionBarState {
  if (!permissions) {
    return {
      showSave: false,
      showSubmit: false,
      showReturn: false,
      showApprove: false,
    };
  }

  return {
    showSave: permissions.canEdit,
    showSubmit: permissions.canSubmit,
    showReturn: permissions.canReturn,
    showApprove: permissions.canApprove,
  };
}
